export const GET_CATEGORY = (alias) => {
  let category = {
    "categoryAlias": "dog",
    "categoryTitle": "狗狗",
    "sizeAlias": "mini",
    "sizeTitle": "迷你型 (3kg以下)",
  };

  CATEGORY.some(categoryItem => {
    return categoryItem.children.some(sizeItem => {
      if(sizeItem.alias === alias) {
        category = {
          "categoryAlias": categoryItem.alias,
          "categoryTitle": categoryItem.title,
          "sizeAlias": sizeItem.alias,
          "sizeTitle": sizeItem.title,
        };
        return true
      }
    })
  });

  return category
};

export const CATEGORY = [
  {
    "alias": "dog",
    "title": "狗狗",
    "children": [
      {
        "alias": "mini",
        "title": "迷你 (3kg以下)"
      },
      {
        "alias": "small",
        "title": "小型 (3-5kg)"
      },
      {
        "alias": "mediumsmall",
        "title": "中小型 (6-8kg)"
      },
      {
        "alias": "medium",
        "title": "中型 (9-15kg)"
      },
      {
        "alias": "mediumlarge",
        "title": "中大型 (16-24kg)"
      },
      {
        "alias": "large",
        "title": "大型 (25kg以上)"
      }
    ]
  },
  {
    "alias": "cat",
    "title": "貓咪",
    "children": [
      {
        "alias": "short",
        "title": "短毛"
      },
      {
        "alias": "long",
        "title": "長毛"
      }
    ]
  },
  {
    "alias": "duck",
    "title": "呱呱",
    "children": [
      {
        "alias": "watermelon",
        "title": "西呱"
      },
      {
        "alias": "whitegourd",
        "title": "冬呱"
      },
      {
        "alias": "cantaloupe",
        "title": "哈密呱"
      }
    ]
  }
]
